import React from "react";
import { useHistory } from "react-router-dom";
import styles from "./index.module.scss";

import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import Popover from "@material-ui/core/Popover";
import { useTranslation } from "react-i18next";

export default function UserProfilePopover({
  open,
  anchorEl,
  onClose,
  ...props
}) {
  const history = useHistory();
  const { t } = useTranslation();
  const logOut = () => {
    const actionTakenStatus = localStorage.getItem("action_taken");

    localStorage.clear();

    sessionStorage.clear();
    // history.push('/');
    // localStorage.setItem("action_taken",actionTakenStatus);
    window.location = "/"; // Need to clear the react context after logout.
  };

  return (
    <Popover
      className={styles.popover}
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      elevation={4}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      {...props}
    >
      <div className={styles.contentWrapper}>
        <MenuList>
          <MenuItem onClick={logOut}>
            <ExitToAppIcon
              style={{
                color: "#757575",
                fontSize: "18px",
                marginRight: "10px",
              }}
            />
            {t("header.logout")}
          </MenuItem>
        </MenuList>
      </div>
    </Popover>
  );
}